/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Component service icon.
 */
export const ICON_CAPABILITY_COMPONENT_SERVICE = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#1D9BE2" height="8" rx="1" width="12" x="10" y="20" />
    <path
      d="M24 21C24 20.4477 24.4477 20 25 20H37C37.5523 20 38 20.4477 38 21V35C38 36.6569 36.6569 38 35 38H25C24.4477 38 24 37.5523 24 37V21Z"
      fill="#1D9BE2"
    />
    <path
      d="M10 31C10 30.4477 10.4477 30 11 30H21C21.5523 30 22 30.4477 22 31V37C22 37.5523 21.5523 38 21 38H12C10.8954 38 10 37.1046 10 36V31Z"
      fill="#1D9BE2"
    />
    <path
      d="M10 13C10 11.3431 11.3431 10 13 10H36C37.1046 10 38 10.8954 38 12V17C38 17.5523 37.5523 18 37 18H11C10.4477 18 10 17.5523 10 17V13Z"
      fill="#1D9BE2"
    />
    <path
      clipRule="evenodd"
      d="M7.02743 15.5275C7.02744 10.833 10.833 7.02747 15.5274 7.02747L31.4023 7.02747C32.2307 7.02747 32.9023 6.35589 32.9023 5.52747C32.9023 4.69904 32.2307 4.02747 31.4023 4.02747L15.5274 4.02747C9.17617 4.02747 4.02744 9.17619 4.02743 15.5275L4.02743 35.0987C4.02743 35.9271 4.69901 36.5987 5.52743 36.5987C6.35586 36.5987 7.02743 35.9271 7.02743 35.0987L7.02743 15.5275Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M40.9915 32.4916C40.9915 37.186 37.1859 40.9916 32.4915 40.9916L16.6166 40.9916C15.7882 40.9916 15.1166 41.6631 15.1166 42.4916C15.1166 43.32 15.7882 43.9916 16.6166 43.9916L32.4915 43.9916C38.8428 43.9916 43.9915 38.8429 43.9915 32.4916L43.9915 12.9203C43.9915 12.0919 43.3199 11.4203 42.4915 11.4203C41.6631 11.4203 40.9915 12.0919 40.9915 12.9203L40.9915 32.4916Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
  </svg>
);
